import React, { useEffect, useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withRouter } from 'react-router-dom';
import SellerwiseMargins from '../../components/SellerwiseMargins';
import ConsolidatedMargins from '../../components/ConsolidatedMargins';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),

  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});



const EnjoyfreshMargins = (props) => {
  const classes = props.classes;
  // console.log("props login",props.login)
  let session = sessionStorage.getItem('user');
  const [isLoading, setLoading] = useState(false);
  const [countryid, setCountryid] = useState(session ? `${JSON.parse(session).countryId}` : "");
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    // console.log(newValue);
    setValue(newValue);

  };
  return (<div>
    <Tabs value={value} onChange={handleChange} classes={{ root: classes.tabRoot }}>
      <Tab label="Seller Wise" />
      <Tab label="Consolidated" />
    </Tabs>

    {value === 0 && <SellerwiseMargins />}
    {value === 1 && <ConsolidatedMargins />}
  </div>)
};

export default withRouter(EnjoyfreshMargins);
